module.exports = __webpack_public_path__ + "img/icon2.09bf1b21.svg";